import Tesseract from 'tesseract.js';

export const extractTextFromImage = async (imageFile) => {
  try {
    const result = await Tesseract.recognize(
      imageFile,
      'eng',
      {
        logger: (info) => {
          if (info.status === 'recognizing text') {
            console.log(`OCR Progress: ${Math.round(info.progress * 100)}%`);
          }
        },
      }
    );
    
    return result.data.text.trim();
  } catch (error) {
    console.error('OCR extraction error:', error);
    throw new Error('Failed to extract text from image');
  }
};

export const extractTextFromImageURL = async (imageUrl) => {
  try {
    const result = await Tesseract.recognize(imageUrl, 'eng');
    return result.data.text.trim();
  } catch (error) {
    console.error('OCR URL extraction error:', error);
    throw new Error('Failed to extract text from image URL');
  }
};

export const extractTextWithConfidence = async (imageFile) => {
  try {
    const result = await Tesseract.recognize(imageFile, 'eng');
    
    return {
      text: result.data.text.trim(),
      confidence: result.data.confidence,
      words: result.data.words.map(word => ({
        text: word.text,
        confidence: word.confidence,
      })),
    };
  } catch (error) {
    console.error('OCR confidence extraction error:', error);
    throw error;
  }
};

export const detectLanguage = async (imageFile) => {
  try {
    const result = await Tesseract.detect(imageFile);
    return result.data;
  } catch (error) {
    console.error('Language detection error:', error);
    throw error;
  }
};